import { HardwareModels } from "types/productTypes";

export const HARDWARE_MODELS: HardwareModels[] = [
  HardwareModels.PicoNeo3ProEye,
  HardwareModels.Pico4Enterprise,
  HardwareModels.Dpvr,
  HardwareModels.PicoSwan,
  HardwareModels.HtcFocusVision,
];
